import { useEffect, useState, useCallback } from 'react';

/**
 * 判断是否在小程序环境
 * @returns [isMiniProgram]
 */
export default function useWxjsEnv() {
  const [isMiniProgram, setIsMiniProgram] = useState<boolean>(false);
  const wxSdkReady = useCallback(() => {
    setIsMiniProgram(window.__wxjs_environment === 'miniprogram');
  }, []);
  useEffect(() => {
    if (!isMiniProgram) {
      document.addEventListener('WeixinJSBridgeReady', wxSdkReady, false);
    }
  }, [wxSdkReady, isMiniProgram]);
  return {
    isMiniProgram,
  };
}
